export function updateUrlWixPartnerGetStartedTnCAcceptedUrlsQueryParams(
  url: string | URL,
  requestorValue: string,
  sourceValue: string
) {
  const parsedUrl = new URL(url);
  parsedUrl.searchParams.set('requestor', requestorValue);
  parsedUrl.searchParams.set('source', sourceValue);
  return parsedUrl.toString();
}
